function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "chevron_svg__a",
  d: "M0 0h16v15.466H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "chevron_svg__c",
  d: "M0 .001h14.454v9.005H0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(-1 -2.767)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "chevron_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#chevron_svg__a"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#chevron_svg__b)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1 0 0 -1 1 12.566)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "chevron_svg__d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#chevron_svg__c"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M14.298 7.42c-.486-.675-1.166-1.218-1.77-1.792-.64-.606-1.278-1.213-1.918-1.818C9.368 2.633 8.172 1.367 6.852.272 6.32-.17 5.694-.048 5.286.468 4.284 1.73 3.192 2.886 2.298 4.232 1.424 5.546.606 6.919.036 8.384c-.224.57.652.85.97.395.888-1.268 1.712-2.568 2.698-3.772.744-.909 1.528-1.87 2.4-2.703.98 1.004 2.026 1.96 3.028 2.933L10.94 6.99c.626.605 1.224 1.3 1.958 1.784.83.547 1.98-.547 1.4-1.353",
  mask: "url(#chevron_svg__d)"
}))));

function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTUiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxNSAxMCI+DQogICAgPGRlZnM+DQogICAgICAgIDxwYXRoIGlkPSJwcmVmaXhfX2EiIGQ9Ik0wIDBIMTZWMTUuNDY2SDB6Ii8+DQogICAgICAgIDxwYXRoIGlkPSJwcmVmaXhfX2MiIGQ9Ik0wIDAuMDAxTDE0LjQ1NCAwLjAwMSAxNC40NTQgOS4wMDYgMCA5LjAwNnoiLz4NCiAgICA8L2RlZnM+DQogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMSAtMi43NjcpIj4NCiAgICAgICAgPG1hc2sgaWQ9InByZWZpeF9fYiIgZmlsbD0iI2ZmZiI+DQogICAgICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNwcmVmaXhfX2EiLz4NCiAgICAgICAgPC9tYXNrPg0KICAgICAgICA8ZyBtYXNrPSJ1cmwoI3ByZWZpeF9fYikiPg0KICAgICAgICAgICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgLTEgMSAxMi41NjYpIj4NCiAgICAgICAgICAgICAgICA8bWFzayBpZD0icHJlZml4X19kIiBmaWxsPSIjZmZmIj4NCiAgICAgICAgICAgICAgICAgICAgPHVzZSB4bGluazpocmVmPSIjcHJlZml4X19jIi8+DQogICAgICAgICAgICAgICAgPC9tYXNrPg0KICAgICAgICAgICAgICAgIDxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0xNC4yOTggNy40MmMtLjQ4Ni0uNjc1LTEuMTY2LTEuMjE4LTEuNzctMS43OTItLjY0LS42MDYtMS4yNzgtMS4yMTMtMS45MTgtMS44MThDOS4zNjggMi42MzMgOC4xNzIgMS4zNjcgNi44NTIuMjcyIDYuMzItLjE3IDUuNjk0LS4wNDggNS4yODYuNDY4IDQuMjg0IDEuNzMgMy4xOTIgMi44ODYgMi4yOTggNC4yMzIgMS40MjQgNS41NDYuNjA2IDYuOTE5LjAzNiA4LjM4NGMtLjIyNC41Ny42NTIuODUuOTcuMzk1Ljg4OC0xLjI2OCAxLjcxMi0yLjU2OCAyLjY5OC0zLjc3Mi43NDQtLjkwOSAxLjUyOC0xLjg3IDIuNC0yLjcwMy45OCAxLjAwNCAyLjAyNiAxLjk2IDMuMDI4IDIuOTMzTDEwLjk0IDYuOTljLjYyNi42MDUgMS4yMjQgMS4zIDEuOTU4IDEuNzg0LjgzLjU0NyAxLjk4LS41NDcgMS40LTEuMzUzIiBtYXNrPSJ1cmwoI3ByZWZpeF9fZCkiLz4NCiAgICAgICAgICAgIDwvZz4NCiAgICAgICAgPC9nPg0KICAgIDwvZz4NCjwvc3ZnPg0K";
export { SvgChevron as ReactComponent };